var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"\n    py-1.5\n    px-4\n    rounded-md\n    font-bold\n    text-sm\n    min-w-max\n  ",class:{'text-white bg-dodgerblue hover:bg-blue-400': _vm.isPrimary,
  'bg-white text-gray-400 border-gray-400 border-2': !_vm.isPrimary }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }